import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import { Send } from 'react-feather';

export default function ChatInput({ inputValue, onChange, onSend, onKeyPress, isLoading, isLoadingSession, sessionId }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        borderTop: `1px solid ${theme.palette.divider}`,
        padding: theme.spacing(2, 3),
        backgroundColor: theme.palette.background.paper
      }}
    >
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        <TextField
          fullWidth
          multiline
          maxRows={4}
          placeholder="How can RiseAI help?"
          value={inputValue}
          onChange={onChange}
          onKeyPress={onKeyPress}
          disabled={isLoading || isLoadingSession || !sessionId}
          variant="outlined"
          size="small"
          sx={{
            '& .MuiOutlinedInput-root': {
              backgroundColor: theme.palette.background.default,
              '&.Mui-focused fieldset': {
                borderColor: theme.palette.common.white
              }
            }
          }}
        />
        <IconButton
          color="primary"
          onClick={onSend}
          disabled={!inputValue.trim() || isLoading || isLoadingSession || !sessionId}
          sx={{
            backgroundColor: theme.palette.riseAiPurple,
            color: theme.palette.common.white,
            '&:hover': {
              backgroundColor: theme.palette.riseAiPurple,
              opacity: 0.9
            },
            '&.Mui-disabled': {
              backgroundColor: theme.palette.action.disabledBackground
            }
          }}
        >
          <Send size={18} />
        </IconButton>
      </Box>
      <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mt: 1, display: 'block', textAlign: 'center' }}>
        Check AI content for accuracy.
      </Typography>
    </Box>
  );
}
